module.exports = __webpack_public_path__ + "static/media/cagliostro.c64b5837.png";